import { RevxDiscTextItem } from 'components/RevxDiscTextItem';

const CommonOneofSvcMessage = ({ message }: { message?: string }) => {
  return (
    <>
      {Boolean(message) && (
        <div
          className="jobconfig-jobOption-content-disc"
          style={{ marginLeft: 7 }}
        >
          <RevxDiscTextItem>
            <div>
              <p style={{ marginBottom: 0 }}>{message?.replaceAll('*', '')}</p>
            </div>
          </RevxDiscTextItem>
        </div>
      )}
    </>
  );
};

export default CommonOneofSvcMessage;
